











































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "QHeader",
})
export default class QHeader extends Vue {
  public isChangeLanguage = false;
  public isCall = false;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  public changeLanguage() {
    this.isChangeLanguage = true;
  }

  public call() {
    this.isCall = true;
  }
}
